<template>
  <component
    :is="pageEditorStore.editorBlock?.viewComponent"
    v-if="pageEditorStore.editorBlock"
    :style="{ 'font-family': isOnHub ? '' : `'${fontFamily}', sans-serif` }"
    :block-id="pageEditorStore.editorBlock?.id"
    :uuid="
      pageEditorStore.editorBlock?.editorData.name ||
      pageEditorStore.editorBlock?.uuid
    "
    :block-uuid="pageEditorStore.editorBlock?.uuid"
    class="!bg-transparent !p-0"
    :form-data="pageEditorStore.editorBlock?.editorData"
    :block-type="pageEditorStore.editorBlock?.type"
    is-in-iframe
    @update="onComponentUpdate"
  />
  <div v-else class="p-5 text-center text-red-500">
    Block with id {{ blockId }} is not found
  </div>
</template>

<script setup lang="ts">
import { usePageEditor } from '~/stores/page-editor'

definePageMeta({
  layout: false,
})

const pageEditorStore = usePageEditor()
const route = useRoute()
const blockId = route.params.id as string
const isPopup = route.query.id !== undefined
const { sendResize, initBridge } = useFrameBridge()

onMounted(() => {
  nextTick(() => {
    !isPopup && sendResize('mounted')
  })
})

onBeforeMount(() => {
  // TODO: it looks like we could rely just on resize event for all cases
  !isPopup && initBridge()
})

const isOnHub = computed(() => {
  return route.query.target === 'hub'
})

const fontFamily = 'Montserrat'

const resizeHeadScript = {
  tagPosition: 'bodyClose',
  children: `
        window.addEventListener('load', () =>
          setTimeout(window.parent.postMessage(
            {
              message_type: 'resize',
              frameHeight: document.body.scrollHeight,
              url: document.location.href,
              stage: 'dom',
            },
            '*'
          ), 0)
        )
      `,
}

useHead({
  // @ts-ignore-next-line strange types issue
  link: [
    ...(isOnHub.value
      ? []
      : [
          {
            rel: 'preconnect',
            href: 'https://fonts.googleapis.com',
          },
          {
            rel: 'preconnect',
            href: 'https://fonts.gstatic.com',
            crossorigin: 'anonymous',
          },
          {
            rel: 'stylesheet',
            href: `https://fonts.googleapis.com/css2?family=${fontFamily}:wght@300;400;500;700&display=swap`,
          },
        ]),
  ], // @ts-ignore-next-line strange types issue
  script: [...(isPopup ? [] : [resizeHeadScript])],
})

function onComponentUpdate() {
  !isPopup && process.client && sendResize('update')
}

async function load() {
  // iframe mode for SSR/CSR based on /iframe path
  pageEditorStore.setIframeMode()
  await pageEditorStore.fetchPageBlock(blockId)
}

onBeforeMount(async () => {
  await load()
})

onServerPrefetch(async () => {
  await load()
})
</script>
